module.exports.notFound = {
  vi: {
    title: 'Avalon: The Resistance | 404',
    description: 'Không tìm thấy trang =(',
  },
  pt: {
    title: 'Avalon: The Resistance | 404',
    description: 'Página não encontrada =(',
  },
  en: {
    title: 'Avalon: The Resistance | 404',
    description: 'Page not found =(',
  },
  ru: {
    title: 'Авалон: Сопротивление | 404',
    description: 'Страница не найдена =(',
  },
  'zh-TW': {
    title: '阿瓦隆：反抗勢力 | 404',
    description: '頁面未找到 =(',
  },
  'zh-CN': {
    title: '阿瓦隆：反抗组织 | 404',
    description: '页面未找到 =(',
  },
  es: {
    title: 'Avalon: La Resistencia | 404',
    description: 'Página no encontrada =(',
  },
};
